module.exports = __webpack_public_path__ + "media/flags/ro-a1043ac5.svg";